import { assertNever } from 'owa-assert';
import { getUserMailboxInfo, MailboxInfo, MailboxType } from 'owa-client-ids';
import createExplicitLogonRequest from './createExplicitLogonRequest';
import { getConnectedAccountRequestOptions } from 'owa-connected-account-headers';
import { RequestOptions, getRequestOptionsOrDefault } from 'owa-headers-core';

export default async function getDefaultRequestOptions(
    mailboxInfo: MailboxInfo
): Promise<RequestOptions | null> {
    if (mailboxInfo) {
        switch (mailboxInfo.type) {
            case MailboxType.GroupMailbox:
                return createExplicitLogonRequest(mailboxInfo.deprecatedMailboxId, mailboxInfo);
            case MailboxType.UserMailbox:
                if (mailboxInfo.primarySmtpAddress != getUserMailboxInfo().primarySmtpAddress) {
                    return await getConnectedAccountRequestOptions(mailboxInfo);
                } else {
                    return getRequestOptionsOrDefault(mailboxInfo);
                }
            default:
                return assertNever(mailboxInfo.type);
        }
    } else {
        return null;
    }
}
